const EMBROIDERY_UID_PATTERN = /-emb(_|$)/;

const isEmbroideryProduct = (productUid: string | undefined): boolean => {
  if (!productUid) return false;
  return EMBROIDERY_UID_PATTERN.test(productUid);
};

export default isEmbroideryProduct;
